import historyTabTemplate from './historyTabTemplate';

export default {
  ...historyTabTemplate([], ({ audit }) => audit.read),
  componentState: ({ url }) => ({ url, category: 'all', code: null }),
};
